import ApolloClient from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { WebSocketLink } from "apollo-link-ws";
import { split } from "apollo-link";
import { HttpLink } from "apollo-link-http";
import { setContext } from "apollo-link-context";
import { getMainDefinition } from "apollo-utilities";

const defaultHeaders = {
  "content-type": "application/json",
  "X-Schema-Preview": "partial-update-mutation",
  Authorization: `Bearer ${__FAUNADB_CLIENT_SECRET__}`,
};

const wsProtocol = window.location.protocol === "https:" ? "wss" : "ws";

const wsLink = new WebSocketLink({
  uri: `${wsProtocol}://${window.location.host}/api/graphql`,
  options: {
    reconnect: true,
    lazy: true,
  },
  connectionParams: async () => {
    return {
      headers: defaultHeaders,
    };
  },
});

const httpLink = new HttpLink({
  uri: `/api/graphql`,
  headers: defaultHeaders,
});

const link = split(
  ({ query }) => {
    const { kind, operation } = getMainDefinition(query);
    return kind === "OperationDefinition" && operation === "subscription";
  },
  wsLink,
  httpLink
);

const client = new ApolloClient({
  // link: authLink.concat(link),
  link: link,
  cache: new InMemoryCache({
    addTypename: true,
  }),
  defaultOptions: {
    watchQuery: {
      returnPartialData: true,
      pollInterval: 10000,
      fetchPolicy: "cache-and-network",
      errorPolicy: "all",
    },
  },
});

export { client };
